import React from 'react'
const SIZE = 24
export const TenbaggerLogo = ({...props}: React.ImgHTMLAttributes<HTMLImageElement>) => {
    return <img src="/svgs/logo.svg" alt="Tenbagger" width={SIZE} height={SIZE} {...props}/>
}
